<template>
  <div>
    <tree-node
      v-for="(node, index) in nodes"
      :key="index"
      :node="node"
      :parents="[]"
      :index="index"
    ></tree-node>

  </div>
</template>

<script>
import eventBus from '@/component/common/EventBus'

export default {
  props: {
    nodes: { type: Array }
  },
  data () {
    return {
      drag: {
        from: null
      }
    }
  },
  computed: {
    myNodes: {
      get () {
        return this.nodes
      },
      set (value) {
        console.log('------------------------!!!!')
        // "깨끗한"참조 객체를 가지려면 원래 속성의 모든 값을 제거하십시오.
        let length = this.nodes.length
        for (let i = 0; i < length; i++) {
          this.nodes.shift(i)
        }
        // 그런 다음 콘솔에 오류를보고하지 않도록 개체 딥 복사 (대상에 대한 참조 반환)
        this.nodes = Object.assign(this.nodes, value)
      }
    }
  },
  created () {
    eventBus.$on('add-tree-node', this.onAdd)
    eventBus.$on('drag-tree-node', this.onDrag)
    eventBus.$on('drag-enter-tree-node', this.onDragEnter)
    eventBus.$on('drop-tree-node', this.onDrop)
    eventBus.$on('drop-tree-node-sibling', this.onDropSibling)
    eventBus.$on('remove-tree-node', this.onRemove)
  },
  methods: {
    onAdd (type) {
      this.from = type
    },
    onDrag (node, component, e) {
      // console.log('onDrag', e)
      this.from = component
    },
    onDragEnter (node, component, e) {
      // console.log('onDragEnter', e)
    },
    onDropSibling (node, component, e) {
      console.log('onDropSibling ', this.from, '--->', component)
      const to = component
      const from = this.from
      this.from = null

      if (typeof from === 'string') {
        const node = {
          type: `${from}`,
          attrs: {},
          components: []
        }
        let nodes = this.myNodes
        if (to.parent) {
          nodes = to.parent.components
        }

        if (component.index + 1 === nodes.length) {
          nodes.push(node)
        } else {
          nodes.splice(component.index + 1, 0, node)
        }
        this.myNodes = this.myNodes.map(node => { return node })
        return
      }

      if (from._uid === to._uid) {
        return
      }

      const hasParent = to.parents.filter(parent => parent._uid === from._uid)
      if (hasParent.length > 0) {
        console.log('STOP')
        return
      }

      const fromParentUID = from.parents.length > 0 ? from.parents[from.parents.length - 1]._uid : -1
      const toParentUID = to.parents.length > 0 ? to.parents[to.parents.length - 1]._uid : -1

      if (fromParentUID > 0 && fromParentUID === toParentUID) {
        const n = from.parent.components.filter((node, index) => index !== from.index)
        n.splice(component.index + 1, 0, from.node)
        from.parent.components = n
      } else if (!fromParentUID && !toParentUID) {
        const n = this.myNodes.filter((node, index) => index !== from.index)
        if (component.index + 1 === this.myNodes.length) {
          n.push(from.node)
        } else {
          n.splice(component.index + 1, 0, from.node)
        }
        this.myNodes = n
      } else {
        if (to.parent) {
          if (component.index + 1 === to.parent.components.length) {
            to.parent.components.push(from.node)
          } else {
            to.parent.components.splice(component.index + 1, 0, from.node)
          }
        } else {
          if (component.index + 1 === this.myNodes.length) {
            this.myNodes.push(from.node)
          } else {
            this.myNodes.splice(component.index + 1, 0, from.node)
          }
        }

        if (from.parent) {
          from.parent.components = from.parent.components.filter((node, index) => index !== from.index)
        } else {
          this.myNodes = this.myNodes.filter((node, index) => index !== from.index)
        }
      }
      // this.myNodes = this.nodes
    },
    onDrop (node, component, e) {
      console.log('onDrop ', this.from, '--->', component)
      const to = component
      const from = this.from
      this.from = null

      if (typeof from === 'string') {
        to.node.components = to.node.components || []
        to.node.components.push({
          type: `${from}`,
          attrs: {},
          components: []
        })
        this.myNodes = this.myNodes.map(node => { return node })
        return
      }

      if (from._uid === to._uid) {
        return
      }

      const hasParent = to.parents.filter(parent => parent._uid === from._uid)
      if (hasParent.length > 0) {
        console.log('STOP')
        return
      }
      // if (to.parent) {
      //   to.parent.components = to.parent.components.filter((item, index) => index !== item.index)
      // }

      if (from.parent) {
        from.parent.components = from.parent.components.filter((node, index) => index !== from.index)
      } else {
        this.myNodes = this.myNodes.filter((node, index) => index !== from.index)
      }
      to.node.components = to.node.components || []
      console.log('to.node.components', to.node.components)
      to.node.components.push(from.node)
      // this.$nextTick(function () {
      //   to.status = true
      //   // this.$set(to, 'opend', true)
      //   console.log('to.node', to)
      // })
    },
    onRemove (node, component, e) {
      if (component.parent) {
        console.log('remove', component.parent.components)
        component.parent.components = component.parent.components.filter((node, index) => index !== component.index)
        console.log('remove', component.parent.components)
      } else {
        this.myNodes = this.myNodes.filter((node, index) => index !== component.index)
      }
      this.myNodes = this.myNodes.map(node => { return node })

      // console.log('remove', node)
    }
  },
  components: {
    TreeNode: () => import('./TreeNode')
  }
}
</script>
